<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          @click="openDetailDialog(scope.row)"
        >详情
        </el-button>
        <el-button
          type="text"
          size="small"
          @click="openReportDialog(scope.row)"
          v-if="scope.row.taskStatus === 2"
        >报告
        </el-button>
      </template>
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-if="projectFlag"
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="deviceIdSearch" slot-scope="scope">
        <el-select
          v-if="deviceFlag"
          v-model="query.deviceId"
          placeholder="请选择设备"
          style="width: 100%"
          @change="(value)=>deviceChange(value)"
        >
          <el-option
            v-for="item in deviceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
    <el-dialog
      title="详情"
      :visible.sync="detailFlag"
      :modal-append-to-body="false"
      width="70%"
      @close="closeDetailDialog"
      append-to-body
    >
<!--      <el-row>-->
<!--        <el-button-->
<!--          type="success"-->
<!--          icon="el-icon-switch-button"-->
<!--          style="float: right;margin:5px"-->
<!--          size="small"-->
<!--          v-show="finishBtnFlag"-->
<!--          @click="finishTask"-->
<!--        >完 成-->
<!--        </el-button>-->

<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-video-play"-->
<!--          style="float: right;margin:5px"-->
<!--          size="small"-->
<!--          v-show="startBtnFlag"-->
<!--          @click="startTask"-->
<!--        >开 始-->
<!--        </el-button>-->
<!--      </el-row>-->
      <avue-form
        ref="editForm"
        v-model="form"
        :option="detailOption"
        label-width="150px"
        margin-top="0"
      >
        <template slot-scope="scope" slot="taskLists">
          <avue-crud
            v-if="taskListFlag"
            :option="listOption"
            :table-loading="loading"
            :data="listData"
            v-model="taskListForm"
            @row-update="taskListUpdate"
          >
          </avue-crud>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog
      title="报告"
      :visible.sync="reportFlag"
      :modal-append-to-body="false"
      width="70%"
      @close="closeReportDialog"
      append-to-body
    >
      <avue-form
        ref="editForm"
        v-model="form"
        :option="reportOption"
        label-width="150px"
        margin-top="0"
      >
        <template slot-scope="scope" slot="taskLists">
          <avue-crud
            :option="listOption"
            :table-loading="loading"
            :data="listData"
            v-model="taskListForm"
          >
          </avue-crud>
        </template>
      </avue-form>
      <template slot="footer">
        <div>
          <el-button type="primary" @click="printReport(form)"><span class="el-icon-printer"></span>  打 印</el-button>
        </div>
      </template>
    </el-dialog>
    <reportPrint 
      ref="reportPrint"
    ></reportPrint>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update , getTaskList,getReport} from "@/api/crmedical/device/deviceinspecttask";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {getDeviceId} from "@/api/crmedical/device/device";
  import reportPrint from "./report-print";

  export default {
    components:{
      reportPrint,
    },
    data() {
      return {
        reportFlag: false,
        detailFlag: false,
        startBtnFlag: false,
        finishBtnFlag: false,
        taskListFlag: true,
        deviceFlag: true,
        projectFlag: true,
        projectList: [],
        deviceList: [],
        form: {},
        taskListForm: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        listOption:{
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: false,
          addBtn: false,
          editBtn: true,
          delBtn: false,
          indexLabel:'序号',
          columnBtn: false,
          align:'left',
          refreshBtn: false,
          menu:false,
          column: [
            {
              label: "设备名称",
              prop: "deviceName",
              disabled: true,
              overHidden: true,
              span: 24,
            },
            {
              label: "巡检状态",
              prop: "errorFlag",
              type: 'radio',
              span: 24,
              dicData: [
                {
                  label: '异常',
                  value: 1,
                },
                {
                  label: '正常',
                  value: 0,
                },
              ],
              props: {
                label: 'label',
                value: 'value',
              },
            },
            {
              label: "实际巡检时间",
              prop: "realInspectTime",
              type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            {
              label: "实际巡检人",
              prop: "realInspectManName",
              overHidden: true,
            },
            {
              label: "巡检标准",
              prop: "standards",
              type: 'textarea',
              overHidden: true,
              disabled: true,
              span: 24,
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              type: 'textarea',
            },
            {
              label: '图片',
              prop: 'imgStr',
              type: 'upload',
              span: 24,
              propsHttp: {
                res: 'data',
                url: 'link',
                name: 'originalName',
              },
              dataType: 'string',
            },
          ],
        },
        detailOption:{
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          column: [
            {
              label: "任务名称",
              prop: "name",
              disabled: true,
            },
            {
              label: "任务开始时间",
              prop: "startTime",
              disabled: true,
            },
            {
              label: "任务结束时间",
              prop: "endTime",
              disabled: true,
            },
            {
              label: "任务明细",
              prop: "taskLists",
              disabled: true,
              formslot: true,
              span: 24
            }
          ]
        },
        reportOption:{
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          column: [
            {
              label: "项目名称",
              prop: "projectName",
              disabled: true,
              span: 8,
            },
            {
              label: "巡检班组",
              prop: "groupName",
              disabled: true,
              span: 8,
            },
            {
              label: "巡检人",
              prop: "realUserNames",
              disabled: true,
              span: 8,
            },
            {
              label: "任务开始时间",
              prop: "startTime",
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              disabled: true,
              span: 8,
            },
            {
              label: "任务结束时间",
              prop: "endTime",
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              disabled: true,
              span: 8,
            },
            {
              label: "巡检数量",
              prop: "allCount",
              disabled: true,
              span: 8,
            },
            {
              label: "异常数量",
              prop: "errorCount",
              disabled: true,
              span: 8,
            },
            {
              label: "任务明细",
              prop: "taskLists",
              disabled: true,
              formslot: true,
              span: 24
            }
          ]
        },
        option: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          addBtn:false,
          editBtn:false,
          delBtn:false,
          indexLabel: '序号',
          selection: false,
          columnBtn: false,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
            },
            {
              label: "项目名称",
              prop: "project",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              search: true,
              searchslot:true,
              hide: true,
              display: false,
            },
            {
              label: "包含设备",
              prop: "deviceId",
              search: true,
              searchslot:true,
              hide: true,
              display: false,
            },
            {
              label: "任务名称",
              prop: "name",
              search: true,
              overHidden: true,
              maxlength: 30,
              showWordLimit: true,
            },
            {
              label: "包含设备",
              prop: "deviceNames",
              overHidden: true,
            },
            {
              label: "任务开始时间",
              prop: "startTime",
            },
            {
              label: "任务结束时间",
              prop: "endTime",
            },
            {
              label: "任务状态",
              prop: "taskStatus",
              display: false,
              type: 'select',
              dicUrl: 'api/blade-system/dict/dictionary?code=task_status',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'string',
              search: true,
            },
            {
              label: "备注",
              prop: "remark",
            },
          ]
        },
        data: [],
        listData: [],
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.deviceinspecttask_add, false),
          viewBtn: this.vaildData(this.permission.deviceinspecttask_view, false),
          delBtn: this.vaildData(this.permission.deviceinspecttask_delete, false),
          editBtn: this.vaildData(this.permission.deviceinspecttask_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    watch: {
      'taskListForm.errorFlag':{
        handler(val){
          var description =this.findObject(this.listOption.column,'description')
          if(val===1){
            description.display=true;
            description.rules=[{
              required: true,
              message: "请输入异常描述",
              trigger: "blur"
            }]
          }else{
            description.display=false;
            description.rules=[]
          }
        },
        immediate: true
      },
    },
    methods: {
      // 打开打印表单
      printReport(form){
        this.$refs.reportPrint.openDialog(form);
      },
      openReportDialog(row){
        getReport({id: row.id}).then(({data})=>{
          this.form = data;
          this.listData = data.taskLists;
          this.reportFlag = true;
        })
      },
      closeReportDialog(){
        this.reportFlag = false;
        this.form = {};
        this.listData = {};
      },
      taskListUpdate(row, index, loading, done){
        this.taskListFlag = false;
        if(row.errorFlag == 0){
          row.description = '';
        }
        console.log(row)
        this.listData[index] = row;
        setTimeout(()=>{
          this.taskListFlag = true;
        },10);
        loading();
      },
      finishTask(){
        update({id: this.form.id,taskStatus: 2,taskLists: this.listData}).then(()=>{
          this.form.taskStatus = 2;
          this.openDetailDialog(this.form);
          this.$message.success('操作成功!');
        }, error => {
          console.log(error);
        });
      },
      startTask(){
        update({id: this.form.id,taskStatus:1}).then(()=>{
          this.form.taskStatus = 1;
          this.openDetailDialog(this.form);
          this.$message.success('操作成功!');
        }, error => {
          console.log(error);
        });
      },
      closeDetailDialog(){
        this.detailFlag = false;
        this.startBtnFlag = false;
        this.finishBtnFlag = false;
        this.form = {};
        this.listData = {};
        this.onLoad();
      },
      openDetailDialog(row){
        this.form = row;
        getTaskList({taskId: row.id}).then(({data}) => {
          if(this.form.taskStatus === 0){
            this.listOption.editBtn = false;
            this.startBtnFlag = true;
          }else if(this.form.taskStatus === 1){
            this.listOption.editBtn = true;
            this.startBtnFlag = false;
            this.finishBtnFlag = true;
          }else if(this.form.taskStatus === 2){
            this.listOption.editBtn = false;
            this.startBtnFlag = false;
            this.finishBtnFlag = false;
          }
          this.listData = data;
          this.detailFlag = true;
        });
      },
      deviceChange(value){
        this.deviceFlag = false;
        this.query.deviceId = value;
        setTimeout(()=>{
          this.deviceFlag = true;
        },10)
      },
      projectChange(value){
        this.projectFlag = false;
        this.query.projectId = value;
        this.query.project = value;
        setTimeout(()=>{
          this.projectFlag = true;
        },10)
        this.deviceList = [];
        this.query.deviceId = '';
        getDeviceId({projectId:value}).then(({data})=>{
          this.deviceList = data;
        })
      },
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query.taskStatus = '';
        this.query.name = '';
        this.query.deviceId = '';
        this.onLoad();
      },
      searchChange(params,done) {
        // this.query = params;
        this.query.taskStatus = params.taskStatus;
        this.query.name = params.name;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log(this.query);
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              getDeviceId({projectId:this.query.projectId}).then(({data})=>{
                this.deviceList = data;
              });
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style>
</style>
